const period = (date) => {
  if (typeof date === "string") {
    date = new Date(date);
  } else if (!isNaN(Number(date))) {
    date = new Date(date * 1000);
  }
  if (date instanceof Date) {
    const hour = date.getHours();
    if ((hour >= 0 && hour < 2) || hour >= 23) {
      return { en: "shenye", cn: "深夜" };
    }
    if (hour >= 2 && hour < 5) {
      return { en: "lingchen", cn: "凌晨" };
    }
    if (hour >= 5 && hour < 8) {
      return { en: "zaochen", cn: "早晨" };
    }
    if (hour >= 8 && hour < 12) {
      return { en: "shangwu", cn: "上午" };
    }
    if (hour >= 12 && hour < 14) {
      return { en: "zhongwu", cn: "中午" };
    }
    if (hour >= 14 && hour < 17) {
      return { en: "xiawu", cn: "下午" };
    }
    if (hour >= 17 && hour < 19) {
      return { en: "bangwan", cn: "傍晚" };
    }
    if (hour >= 19 && hour < 23) {
      return { en: "wanshang", cn: "晚上" };
    }
  }
};
const periodOfHour = (hour) => {
  if (hour >= 0 && hour < 6) {
    return { en: "lingchen", cn: "凌晨" };
  }
  if (hour >= 6 && hour < 12) {
    return { en: "zaochen", cn: "早上" };
  }
  if (hour === 12) {
    return { en: "zhongwu", cn: "中午" };
  }
  if (hour >= 13 && hour < 19) {
    return { en: "xiawu", cn: "下午" };
  }
  if (hour >= 19 && hour < 24) {
    return { en: "wanshang", cn: "晚上" };
  }
};

const periodOfSimple = (date) => {
  if (typeof date === "string") {
    date = new Date(date);
  } else if (!isNaN(Number(date))) {
    date = new Date(date * 1000);
  }
  if (date instanceof Date) {
    const hour = date.getHours();
    if (hour >= 0 && hour < 6) {
      return { en: "lingchen", cn: "凌晨" };
    }
    if (hour >= 6 && hour < 12) {
      return { en: "zaochen", cn: "早上" };
    }
    if (hour >= 12 && hour < 18) {
      return { en: "xiawu", cn: "下午" };
    }
    if (hour >= 18 && hour < 24) {
      return { en: "wanshang", cn: "晚上" };
    }
  }
};
export default period;

export { periodOfHour, periodOfSimple };
